var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.id==1)?_c('div',[_c('Goodlist',{attrs:{"subid":1}})],1):_vm._e(),(_vm.id==2)?_c('div',[_c('Goodlist',{attrs:{"subid":2}})],1):_vm._e(),(_vm.id==3)?_c('div',[_vm._v(" 33333333 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }